/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'Hjem',
	myContent: 'Mitt innhold',
	teamContent: 'Gruppeinnhold',
	folder: '\t\t\t\t Mappe',
	files: 'Filer',
	actionMenu: 'Handlingsmeny',
	myFolder: 'Mine mapper',

	emptyFolderNoContent: 'Ikke noe innhold',

	//EmptyStates
	emptyRecentTitle: 'Du har ikke vist noe innhold nylig.',
	emptyStateTitle: 'Begynn ved å legge til data',
	emptyStateBody: 'Klikk på Last opp data ovenfor eller dra og slipp for å laste opp data.',
	emptySearchResultTitle: 'Søket ditt returnerte ingen resultater.',
	emptyPortalTitle: 'Ingen portaler',
	emptyPortalBody: 'Du har i øyeblikket ingen portaler.',
	emptyWsProjectTitle: 'Begynn ved å opprette en notisbok i Watson Studio.',
	emptyWsProjectBody: 'Når du kommer tilbake til Cognos Analytics, vil notisboken bli vist her.',
	emptyFilteredResultTitle: 'Filtrene du brukte, returnerte ingen resultater.',
	emptyDialogViewTitle: 'Ingen elementer',
	removeFromRecents: 'Fjern fra nyeste',

	// Welcome Banner
	welcomeBannerGreeting: 'Hei. Velkommen til Cognos Analytics.',
	welcomeBannerDescription: 'Cognos Analytics gir brukerne AI-drevne, selvbetjente analysefunksjoner. Se hvordan automatisert dataklargjøring, dataoppdaging og visualiseringer kan gi bedre funderte beslutninger.',
	welcomeBannerDescription_trialUser: 'Du kan komme i gang med en gang ved å ta en titt på introduksjonsvideoen vår, produktomvisningen og flippen Komme i gang.',
	takeTourButtonLabel: 'Få en produktrundtur',
	watchVideoButtonLabel: 'Se video',
	// confirmation dialog
	hideWelcomeBannerMsg: 'Er du sikker på at du vil slå av velkomstbanneret på hjemmesiden din? Du kan når som helst slå det på igjen i Profil og innstillinger > Innstillinger > Generelt. ',
	hideWelcomeBannerTitle: 'Slå av velkomstbanner',
	ok: 'OK',
	cancel: 'Avbryt',
	//howto video dialog
	modal_how_title: 'Hvordan-videoer',
	modal_overview_title: 'Se Cognos Analytics-oversikt',
	modal_how_play: 'Spill av video',
	modal_how_video_title_overview: 'Oversikt',
	modal_how_video_title_getStarted: 'Komme i gang i 11.2',
	modal_how_video_title_newUI: 'Velkommen til den nye Cognos-opplevelsen',
	modal_how_video_title_dataModule: 'Oversikt over datamoduler',
	modal_how_video_title_explore: 'Oversikt over datautforsking',
	modal_how_video_title_dashboard: 'Oversikt over interaktive dashbord',
	modal_how_video_title_reporting: 'Oversikt over rapportering',
	modal_how_video_title_mobile: 'Kraften fra Cognos i håndflaten din',

	// Toolbar
	search: 'Søk',
	addFolder: 'Legg til mappe',
	addLink: 'Legg til link',
	filter: 'Filtrer',
	sort: 'Sorter',
	settings: 'Innstillinger',
	tilesView: 'Flisevisning',
	listView: 'Listevisning',
	columnView: 'Kolonnevisning',

	// Toolbar Actions
	sortBy: 'Sorter etter',
	sortOrder: 'Sorter',
	name: 'Navn',
	modifiedTime: 'Endret',
	type: 'Type',
	ascending: 'Stigende',
	descending: 'Synkende',

	filterType: 'Type',
	filterModificationTime: 'Endret',
	all: 'Alle',
	today: 'I dag',
	yesterday: 'I går',
	pastWeek: 'Siste uke',
	pastMonth: 'Siste måned',
	resetFilters: 'Tilbakestill filtre',

	filterSearchPlaceHolder: 'Filtrer etter nøkkelord',

	resetFilterTag: 'Klikk på X for å tilbakestille filtre.',
	filterTagToolTip: 'Filtre brukt: %{appliedFilters}.',

	folderName: 'Mappenavn',
	addAFolder: 'Legg til en mappe',
	add: 'Legg til',
	error: 'Feil',
	newFolderDefaultName: 'Ny mappe',
	toastCreateNewFolder: '%{nameOfFolder}-mappe ble opprettet i %{tabName}.',
	folderAdded: 'Mappe lagt til',
	refresh: 'Oppdater',
	openFolder: 'Åpne mappe',

	addAUrl: 'Legg til en URL',
	linkName: 'URL-navn',
	linkNamePlaceholder: 'Legg til URL-navn',
	linkDescription: 'Beskrivelse (valgfritt)',
	linkDescriptionPlaceholder: 'Legg til en beskrivelse',
	linkUri: 'URL',
	linkUriPlaceholder: 'Legg til en URL med et godkjent domene',
	acceptableDomains: 'Godkjente domener',
	viewAcceptableDomains: 'Vis godkjente domener',
	mandatoryField: 'Obligatorisk felt',
	linkAdded: 'URL lagt til',
	toastCreateNewLink: '%{nameOfLink} ble lagt til i %{tabName}.',
	noEntries: 'Det er ingen oppføringer på listen over godkjente domener. Ta kontakt med administratoren.',

	compact: 'Komprimert',
	short: 'Kort',
	default: 'Standard',
	rowSize: 'Radstørrelse',

	// GroupyByTypes
	folders: 'Mapper',
	reports: 'Rapporter',
	dashboards: 'Dashbord',
	data: 'Data',
	packages: 'Pakker',
	explorations: 'Utforskinger',
	stories: 'Historie',
	notebooks: 'Notisbøker',
	others: 'Annet',

	// Error Messages
	itemsOverLimit: 'Det oppgitte navnet "%{itemName}" har overskredet maksimumsgrensen (20). Oppgi et annet navn for å fortsette.',
	errorMessageLengthFolderName: 'Oppgi et mappenavn som ikke overskrider 255 tegn.',
	errorMessageLengthLinkName: 'Oppgi et linknavn som ikke overskrider 255 tegn.',
	toastLaunchPerspectiveError: 'Kan ikke åpne %{objectType}.',
	errorNoAccessTitle: 'Hmm, det ser ut som du har ikke tilgang til dette innholdet',
	errorNoAccessBody: 'Kontakt administratoren eller gå til følgende link:',
	errorEnableExternalContent: 'Aktivere eksternt innhold',

	//TableHeader
	lastModified: 'Sist endret',
	location: 'Plassering',
	tenant: 'Leietaker',

	// GetStartedTab
	getStartedLabel: 'Kom i gang med IBM Cognos Analytics',
	learningHowToLabel: 'Opplæringsressurser',
	learningHowToDescription: 'Utvid kunnskapen din og få hjelp ved å delta i fellesskapet, lese dokumentasjon og se på videoer.',
	learningHowToActionLabel: 'Åpne opplæringsruten',
	howToVideosLabel: 'Opplæringsvideoer',
	howToVideosDescription: 'Lær hvordan du bruker IBM Cognos Analytics, og få mer innsikt i dataene dine.',
	howToVideosActionLabel: 'Se videoer',
	acceleratorCatalogLabel: 'Accelerator-katalog',
	acceleratorCatalogDescription: 'Bla gjennom en stadig økende katalog med bransjeeksempler, veiledere om beste praksis, tilpassede visualiseringer og mer.',
	acceleratorCatalogActionLabel: 'Bla gjennom katalog',
	sampleSectionTitle: 'Eksempler',
	sampleSectionDescription: 'Eksperimenter med eksempler som viser alt Cognos Analytics har å tilby.',
	// Samples Section
	createDashboardSampleTitle: 'Hvordan opprette ditt første dashbord',
	createDashboardSampleDescription: 'Start analysereisen din med Cognos-dashbord.',
	covid19SampleTitle: 'COVID-dashbord',
	covid19SampleDescription: 'Se nærmere på hva som er mulig med dette Cognos-dashbordet og analysering av COVID-19-relaterte data og tilpassede utvidelser.',
	sankeySampleTitle: 'Sankey',
	sankeySampleDescription: 'Utvid visualiseringsbiblioteket med tilpassede visualiseringer som Sankey-diagrammet.',
	viewAllSamplesActionLabel: 'Vis alle eksempler',
	byFeatureTitle: 'Etter funksjon',
	byFeatureDescription: 'Bla gjennom Eksempler basert på funksjon, for eksempel kjernefunksjonalitet, tilpassede kontroller, utvidelser, notatbøker og relative datoer.',
	byIndustryTitle: 'Etter bransje',
	byIndustryDescription: 'Bla gjennom eksempler basert på bransje, for eksempel bil, bank og så videre.',
	// SamplesTab
	sampleTabTitle: 'Bli inspirert med våre forhåndsbygde eksempler',
	sampleTabLabel: 'Besøk Accelerator Catalog for å få flere eksempler og utvidelser fra IBM, partnere og kunder',

	// quickLaunch
	quickLaunchLabel: 'Hurtigstart',
	expand: 'Utvid',
	collapse: 'Komprimer',

	// quickLaunch dialog
	quickLaunchModalLabel: 'Begynn med å velge hva du vil opprette.',

	// contentPageView
	contentPageTitleLabel: 'Innhold',
	uploadFile: 'Last opp data',
	new: 'Ny',
	create: 'Opprett',
	more: 'Mer',

	// open dialog
	selectDataSourcesToAdd: 'Velg datakilde(r) som skal legges til.',
	openDialogDefaultTitle: 'Åpne',

	// save dialog
	save: 'Lagre',
	saveAs: 'Lagre som',
	saving: 'Lagrer...',
	selectedDestination: 'Valgt mål: %{nameOfFolder}',
	toastDuplicateFileDifferentType: '\'%{nameOfItem}\' finnes allerede med en annen type. Velg et annet navn.',
	confirmOverwriteTitle: 'Bekreft erstatning av eksisterende data',
	confirmOverwriteMsg: 'Filen \'%{nameOfFile}\' finnes allerede. Vil du erstatte dataene der med dataene fra den valgte filen?',

	// copy move dialog
	copy: 'Kopier',
	move: 'Flytt',
	copyOrMove: 'Kopier eller flytt: ',
	copyOnly: 'Kopier ',
	createShortcut: 'Opprett snarvei',
	createShortcutDialogTitle: 'Opprett snarvei: ',

	// External asset types
	wsProject: 'Watson Studio-prosjekt',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'Pakke',
	dataModule: 'Datamodul',
	exploration: 'Utforsking',
	mode: 'Modus',
	live: 'Aktiv',
	snapshot: 'Snapshot',
	noSnapshotsFound: 'Fant ingen snapshot',
	uploadedFile: 'Opplastet fil',
	fileUpload: 'Last opp data',
	dataSetEx: 'Datasett',
	externalRepository: 'Eksternt datalager',
	queryMode: 'Spørringsmodus',
	queryModeCompatible: 'Kompatibel',
	queryModeDynamic: 'Dynamisk',
	report: 'Rapport',
	activeReport: 'Active Report',
	query: 'Spørring',
	analysis: 'Analyse',
	dashboard: 'Dashbord',
	dashboardTemplate: 'Dashbordmal',
	jupyterNotebook: 'Notisbok',
	wsNotebook: 'Watson Studio-notisbok',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'Historie',
	workspace: 'Arbeidsområde',
	pagelet: 'Side',
	content: 'Innhold',
	directory: 'Navneområder',
	dataSet: 'Datasett',
	powerPlayCube: 'PowerPlay Cube',
	powerPlayReport: 'PowerPlay-rapport',
	powerPlay8Report: 'PowerPlay-rapport',
	powerPlay8ReportView: 'PowerPlay-rapportvisning',
	reportTemplate: 'Rapportmal',
	packageConfigurations: 'Pakkekonfigurasjon',
	agent: 'Agent',
	agentDefinition: 'Agentdefinisjon',
	agentDefinitionView: 'Agentvisning',
	dataMovementTask: 'Dataflyttingsoppgave',
	dataMovementTaskAlias: 'Alias for dataflyttingsoppgave',
	document: 'Dokument',
	DocumentRetention: 'Dokumentegenskaper',
	jobDefinition: 'Jobbdefinisjon',
	job: 'Jobb',
	metricsDataSourceETLTask: 'ETL-oppgave for datakilde for styringsparametere',
	metricsExportTask: 'Eksportoppgave for styringsparametere',
	metricsFileImportTask: 'Filimportoppgave for styringsparametere',
	metricsMaintenanceTask: 'Vedlikeholdsoppgave for styringsparametere',
	planningTask: 'Planleggingsoppgave',
	shortcut: 'Snarvei',
	URL: 'URL',
	launchable: 'Kan startes',
	dataSetFolder: 'Datasettmappe',
	ViewAccessibleLabel: 'Vis %{label}',
	overrideReportOptions: 'Overstyre standard rapportalternativer',
	formats: 'Formater',
	saveReport: 'Lagre rapporten',
	promptForValues: 'Spør meg',
	reportView: 'Rapportvisning',
	html: 'html',
	pdf: 'pdf',
	spreadsheetML: 'Excel',
	xlsxData: 'Excel-data',
	csv: 'csv',
	xml: 'xml',
	txt: 'txt',
	//Details
	details: 'Detaljer',
	open: 'Åpne',
	created: 'Opprettet',
	modified: 'Endret',
	owner: 'Eier',
	dataSource: 'Datakilde',
	share: 'Del',
	addToFavorites: 'Legg til i favoritter',
	properties: 'Egenskaper',
	detailsEmptyStateBody: 'Velg et element for å vise detaljene',
	editNameAndDescription: 'Rediger navn og beskrivelse',
	none: 'Ingen',

	//rename dialog
	nameInvalid: 'Navnet er ugyldig',
	namePlaceholder: 'Oppgi et navn',
	description: 'Beskrivelse',
	descriptionInvalid: 'Beskrivelsen kan ikke overskride 350 tegn.',
	descriptionPlaceholder: 'Oppgi en beskrivelse',
	errorMessageApostropheError: 'Oppgi et filnavn som ikke inneholder både tegnet \' og tegnet "',
	renameCollisionError: '%{name} finnes allerede. Prøv et annet navn.',
	unknownRenameError: 'Endring av elementnavn mislyktes. Kontakt administratoren for å få mer hjelp.',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'Kan ikke åpne den oppgitte mappen.',

	//Upload
	uploadToFolder: "Last opp til <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction}",
	uploadAndLaunch: "Last opp til <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> og start %{launchAction}",
	quickUpload: "Hurtigopplasting",
	quickUploadAndLaunch: "Dra og slipp filer for å laste opp til <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> og åpne i et av følgende områder.",
	unsupportedFilesSingle: "%{files} ble ikke lastet opp fordi den er ugyldig for Hurtigstart.",
	unsupportedFilesMultiple: "Filene ble ikke lastet opp fordi alle filene du velger, må være gyldige for å bruke Hurtigstart.",
	unsupportedFilesSingleInvalid: "%{files} er ugyldig.",
	unsupportedFilesMultipleInvalid: "%{files} er ugyldige.",
	supportedFileTypes: "Bare følgende filtyper er tillatt: %{extensions}.",
	uploadDragAndDrop: "Dra og slipp",
	uploadDragAndDropMessage: "Dra og slipp filen din her for å laste den opp til <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>",

	// searchBar
	searchWasSaved: 'Søkekriteriene \'%{searchTerm}\' ble lagret.',
	searchWasntSaved: 'Søkekriteriene \'%{searchTerm}\' ble ikke lagret.',
	searchSuggestions: 'Forslag',
	savedSearch: 'Lagrede søk',
	searchWasDeleted: 'Søkekriteriene \'%{searchTerm}\' ble slettet.',
	searchWasntDeleted: 'Søkekriteriene \'%{searchTerm}\' ble ikke slettet.',
	savedBarTitle: 'Søk i Cognos Analytics',
	searchContentPageTitle: 'Søk',
	searchContentPageTitleLabel: 'Viser resultater for \'%{searchTerm}\'',
	showingSearchRsult: 'Viser %{resultCount} elementer',
	saveSearch: 'Lagre søk',
	saveTenSearches: 'Du kan lagre 10 søk.',
	deleteASearch: 'Slett ett for å lagre et annet.',
	close: 'Lukk',

	//recent view
	recents: 'Nyeste',
	noAccessRecent: 'Ingen tilgang',
	noAccessRecentMsg: 'Du har ikke tilgang til denne ressursen. Den kan ha blitt deaktivert eller slettet, eller tillatelsene dine kan ha blitt redusert. Kontroller statusen for ressursen på den forventede kildeplasseringen. Du kan fjerne ressursen fra de nyeste elementene ved å klikke på OK.',
	noAccessMsg: 'Du har ikke tilgang til denne ressursen. Den kan ha blitt deaktivert eller slettet, eller tillatelsene dine kan ha blitt redusert.',

	//contextToolbar
	itemsSelected: '%{nameOfSelection} elementer valgt',
	itemSelected: '%{nameOfSelection} element valgt'

});